/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Downloadzip1Inputs */

const zh_common_downloadzip1 = /** @type {(inputs: Common_Downloadzip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载 ZIP`)
};

const en_common_downloadzip1 = /** @type {(inputs: Common_Downloadzip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download ZIP`)
};

const es_common_downloadzip1 = /** @type {(inputs: Common_Downloadzip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar ZIP`)
};

/**
* | output |
* | --- |
* | "Download ZIP" |
*
* @param {Common_Downloadzip1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const common_downloadzip1 = /** @type {((inputs?: Common_Downloadzip1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Downloadzip1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_common_downloadzip1(inputs)
	if (locale === "en") return en_common_downloadzip1(inputs)
	return es_common_downloadzip1(inputs)
});
export { common_downloadzip1 as "common_downloadZip" }